import { cva } from 'class-variance-authority';
import type { Distance, MarginVariant, ParagraphMeta } from '../../../interfaces';

export type SectionSeperatorType = ParagraphMeta & {
  type: 'section_seperator';
  field_margin_variant: MarginVariant;
  field_distance: Distance;
  field_type?: 'section_seperator';
  field_style_type?: 'default';
};

const separator = cva('bg-color-grey-dark h-[1px] w-full p-0', {
  variants: {
    margin: {
      none: 'm-0',
      small: 'my-2',
      medium: 'my-4',
      big: 'my-[4rem]',
    },
  },
});

export const SectionSeperator = ({
  data: { field_margin_variant: margin },
}: {
  data: SectionSeperatorType;
}) => <div className={separator({ margin })} />;
